import React, { useCallback } from 'react';
import { batch, useDispatch } from 'react-redux';

import {
  setSelectedSuperBatchModule,
  setUpdateSuperBatchModuleInterviewModalState,
} from 'features/moduleManagement';
import styles from './SuperBatchInterviewRequired.module.scss';
import Switch from 'components/Switch';

function SuperBatchInterviewRequired({ superBatchModule }) {
  const dispatch = useDispatch();
  const { interview_required: interviewReq } = superBatchModule;

  const handleOnChange = useCallback(
    (event) => {
      batch(() => {
        dispatch(setUpdateSuperBatchModuleInterviewModalState(true));
        dispatch(
          setSelectedSuperBatchModule({
            ...superBatchModule,
            updatedInterviewRequired: event.target.checked,
          })
        );
      });
    },
    [dispatch, superBatchModule]
  );

  return (
    <div className={styles.select}>
      <span className="m-r-5">Mock-Interview?</span>
      <Switch
        checked={Boolean(interviewReq)}
        onChange={handleOnChange}
        className="m-l-xs"
        small
      />
    </div>
  );
}

export default SuperBatchInterviewRequired;
